<template>
    <div>
        <br>
        <h3>One-Day Registrant Information</h3>
        <hr>
        <vue-form :state="formstate">
            <div class="row">
                <div class="col">
                    <validate auto-label class="form-group required-field"
                              :class="fieldClassName(formstate.oneDay)">
                        <label>What day are you planning on attending?</label>

                        <select class="form-control" name="oneDay" required
                                v-model.lazy="state.registrantData.oneDayExtraData.day">
                            <option value="sat">Saturday (11/21/2026)</option>
                            <option value="sun">Sunday (11/22/2026)</option>
                        </select>

                        <field-messages name="oneDay" show="$touched || $dirty || $submitted"
                                        class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>
                    </validate>
                </div>
            </div>
        </vue-form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'OneDay',
        data: function () {
            return {
                formstate: {},
            }
        },
        computed: {
            ...mapGetters({
                state: 'getState',
            }),

        },
        watch: {
            formstate: function (val) {
                this.state.formstate.oneDay = val;
            },
        },
        methods: {
            fieldClassName: function (field) {

                if (!field) {
                    return ''
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success'
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger'
                }
            },
            onSubmit: function () {
                console.log(this.formstate.$valid)
            }
        },
    }
</script>

<style scoped>
/* Existing required field marker */
.required-field > label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}

/* Section heading */
h3 {
  margin: 0 0 14px;
  padding: 18px 22px;

  background: linear-gradient(
      110deg,
      #148f94 0%,
      #427f9e 50%,
      #656dac 100%
  );

  border-radius: 12px;

  color: #ffffff;
  font-family: inherit;
  font-weight: 300;
  line-height: 1.35;
  letter-spacing: 0.025em;
  text-transform: uppercase;
}

hr {
  height: 1px;
  margin: 14px 0 20px;
  border: 0;

  background: linear-gradient(
      to right,
      #80c9c5,
      #d9deef
  );
}

/* Form section */
.row {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  margin: 0;
  padding: 22px;

  background: linear-gradient(
      135deg,
      #eaf6f3 0%,
      #edf0fa 100%
  );

  border: 1px solid #d5e1ea;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(49, 75, 111, 0.08);
}

/* Field panel */
.row > .col {
  box-sizing: border-box;
  width: auto;
  min-width: 0;
  max-width: none;
  padding: 20px;

  background: #ffffff;
  border: 1px solid #dfe6ee;
  border-radius: 11px;
}

.form-group {
  display: block;
  margin-bottom: 0;
}

/* Label */
label {
  display: block;
  margin-bottom: 8px;

  color: #535c98;
  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
}

/* Day dropdown */
.form-control {
  box-sizing: border-box;
  display: block;
  width: 100%;
  min-width: 0;
  height: auto;
  min-height: 48px;
  padding: 12px 14px;

  background: #fbfcfe;
  border: 1px solid #bdcddb;
  border-radius: 9px;
  box-shadow: inset 0 1px 3px rgba(49, 75, 111, 0.04);

  color: #535c98;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.5;

  transition:
      background-color 0.18s ease,
      border-color 0.18s ease,
      box-shadow 0.18s ease;
}

select.form-control {
  cursor: pointer;
}

.form-control:hover {
  border-color: #8faebf;
}

.form-control:focus {
  outline: none;
  background: #ffffff;
  border-color: #168b91;
  box-shadow: 0 0 0 3px rgba(22, 139, 145, 0.15);
}

/* Validation feedback */
.form-control-feedback {
  margin-top: 7px;
  color: #535c98;
  line-height: 1.5;
}

.has-success .form-control {
  border-color: #459b83;
  background: #f5fbf8;
}

.has-success .form-control:focus {
  box-shadow: 0 0 0 3px rgba(69, 155, 131, 0.15);
}

.has-success .form-control-feedback {
  color: #28765f;
}

.has-danger .form-control {
  border-color: #c9606c;
  background: #fff8f9;
}

.has-danger .form-control:focus {
  box-shadow: 0 0 0 3px rgba(201, 96, 108, 0.15);
}

.has-danger .form-control-feedback {
  color: #ad3e50;
}

/* Tablets and smaller devices */
@media (max-width: 767px) {
  .row {
    padding: 14px;
    border-radius: 13px;
  }

  .row > .col {
    padding: 17px;
  }

  h3 {
    padding: 16px 18px;
  }

  label {
    font-size: 16px;
    font-weight: 500;
  }
}

/* Phones */
@media (max-width: 480px) {
  .row {
    padding: 10px;
  }

  .row > .col {
    padding: 14px;
  }

  h3 {
    padding: 14px 16px;
  }

  label {
    font-size: 15px;
    font-weight: 500;
  }
}
</style>
